import { NavBarAccessModel } from '@/types';
import { CustomerRouteConstants } from './constants/RouteConstants';
import { ToolsModel } from '@/services/GeneratedApi';
import { Module } from 'vuex';

// This will override all instances of the text 'mstore' in the app
export const CustomerAppName = '';

export const Components = {
  TaskServices: {},
  WorkflowJob: {},
  WorkflowQueue: {},
  BuiltInListItem: {},
  VerticalWorkflowJobTabs: {},
  CustomIndexingLookup: {}
};

export const Routes = [];

export const NavbarItems: Array<{
  routeName: string;
  hasAccess: (navbarAccess?: NavBarAccessModel) => boolean;
  text: string;
  order?: number;
}> = [];

export const getToolsTreeNodes = (toolsModel: ToolsModel) => [];

export const Store = {
  Modules: {} as Record<string, Module<any, any>>,
  PersistedPaths: [] as string[],
  SessionPersistedPaths: [] as string[]
};
